import React from "react";
import withTranslations from "../../../../../../hocs/withTranslations";
import { compose } from "redux";
import calendarIcon from "./assets/calendar.svg";
import moment from "moment-mini";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import classNames from "classnames";

const FromDateBox = ({ translate, date }) => {
  const isDesktop = useIsDesktop();

  return (
    <div
      className={classNames("flex align-center", {
        "bg-white py-2 px-3 rounded-1": isDesktop
      })}
    >
      <span
        className={classNames("line-height-100 text-black-5 block mr-2", {
          "text-xs": isDesktop,
          "text-xs.1": !isDesktop
        })}
      >
        {translate("from the day:")}
      </span>
      <img
        src={calendarIcon}
        alt=""
        width={isDesktop ? 16 : 10}
        height={isDesktop ? 16 : 10}
        className={"mr-1"}
      />
      <span
        className={classNames("font-semibold line-height-100 text-black", {
          "text-xs": isDesktop,
          "text-xs.1": !isDesktop
        })}
      >
        {moment(date).format("DD.MM.YYYY")}
      </span>
    </div>
  );
};

export default compose(withTranslations)(FromDateBox);
